import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { swiper, swiperSlide, SwiperComponent } from 'vue-awesome-swiper';
import { SwiperOptions } from 'swiper';
import { Campaign, SummerOfExtrasIntroScreensContentFragment } from '@/models';
import { Routes } from '@/router';

@Component({
  name: 'CmgLeaderboardEducationCardModal',
  components: { swiper, swiperSlide },
})
export default class CmgLeaderboardEducationCardModal extends Vue {
  leaderboardSwiper: SwiperComponent | null = null;

  swiperOptions: SwiperOptions = {
    pagination: { el: '.swiper-pagination' },
    navigation: {
      nextEl: '.next-slide',
      prevEl: '.prev-slide',
    },
  };

  isActivating = false;

  mounted() {
    this.$services.config.setSummerOfExtrasIntroScreens();
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.summerLeaderboardEducator.visible;
  }

  get campaign(): Campaign | undefined {
    return this.$appStore.state.ui.modals.summerLeaderboardEducator.args?.campaign;
  }

  get isActivated(): boolean | undefined {
    return this.$appStore.state.ui.modals.summerLeaderboardEducator.args!.isActivated;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get summerExtrasLogo(): string {
    return this.$appStore.state.cms.images.loyalty.summerOfExtras.default;
  }

  get howItWorksImgOne(): string {
    return this.$appStore.state.cms.images.loyalty.educationalCardOne.default;
  }

  get howItWorksImgTwo(): string {
    return this.$appStore.state.cms.images.loyalty.educationalCardTwo.default;
  }

  get howItWorksImgThree(): string {
    return this.$appStore.state.cms.images.loyalty.educationalCardThree.default;
  }

  get learnMoreDemo(): string {
    return this.$appStore.state.cms.images.loyalty.learnMoreDemo.default;
  }

  get learnMoreBadges(): string {
    return this.$appStore.state.cms.images.loyalty.learnMoreBadges.default;
  }

  get campsiteImg(): string {
    return this.$appStore.state.cms.images.loyalty.learnMoreActivate.default;
  }

  get learnMoreBag(): string {
    return this.$appStore.state.cms.images.loyalty.learnMoreBag.default;
  }

  get learnMorePoints(): string {
    return this.$appStore.state.cms.images.loyalty.learnMorePoints.default;
  }

  get yourSummerDashboardFrame(): string {
    return this.$appStore.state.cms.images.loyalty.learnMoreDemo.default;
  }

  get summerOfExtrasIntroScreens(): SummerOfExtrasIntroScreensContentFragment | undefined {
    return this.$services.config.getSummerOfExtrasIntroScreens();
  }

  get slide1Title(): string | undefined {
    return this.summerOfExtrasIntroScreens?.title;
  }

  get slide1Body(): string | undefined {
    return this.summerOfExtrasIntroScreens?.bodySlide1;
  }

  get slide2Description1(): string | undefined {
    return this.summerOfExtrasIntroScreens?.description1;
  }

  get slide2Description2(): string | undefined {
    return this.summerOfExtrasIntroScreens?.description2;
  }

  get slide2Description3(): string | undefined {
    return this.summerOfExtrasIntroScreens?.description3;
  }

  get slide3Description(): string | undefined {
    return this.summerOfExtrasIntroScreens?.bodySlide3;
  }

  onClose(): void {
    this.$services.ui.setModalVisibility('summerLeaderboardEducator', false);
  }

  goToPreviousSlide(): void {
    this.leaderboardSwiper?.swiper?.slidePrev();
  }

  goToNextSlide(): void {
    this.leaderboardSwiper?.swiper?.slideNext();
  }

  async onClickActivate() {
    if (this.isActivating) return;
  
    if (!this.campaign) {
      this.$services.logger.error(
        'Something went wrong joining rewards', { error: new Error('campaign is undefined') }
      );
      return;
    }
  
    try {
      this.isActivating = true;
      const data = await this.$services.reward.optIntoCampaign(this.campaign.id);
      if (data?.awarded) {
        this.onClose();
        this.updateCustomer();
        this.$router.push({ name: Routes.Leaderboard });
      }
    } catch (e: any) {
      this.$services.logger.error('Something went wrong joining rewards', { error: e });
    } finally {
      this.isActivating = false;
    }
  }

  onSwiperReady(swiperInstance: SwiperComponent) {
    this.leaderboardSwiper = this.$refs.leaderboardSwiper as SwiperComponent;
  }

  updateCustomer() {
    this.$services.customer.optInCustomerToSummerOfChipotle();
  }
}
